export const distributorsHeroData = {
  tagline: "DISTRIBUIDORES IT",
  title: "Haz crecer tu negocio de distribución IT con confianza",
  subtitle: "Comercio por suscripción transformado para distribuidores IT. Automatiza facturación, acelera ventas y empodera a tus resellers para hacer crecer tu canal más rápido.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const distributorsStatsData = [
  { number: "99.98%", label: "Precisión en facturación" },
  { number: "70%", label: "Reducción de costes" },
  { number: "25%", label: "Crecimiento de clientes" },
  { number: "24/7", label: "Portal autoservicio" }
];

export const billingFeaturesData = [
  {
    id: 1,
    title: "99.98% precisión en facturación",
    description: "Confía en reconciliación automática y facturación para reducir errores costosos.",
    icon: "Target"
  },
  {
    id: 2,
    title: "Acelera cobros de pagos",
    description: "Habilita pagos directos en el portal de resellers para un flujo de caja más rápido.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Integración sin fricciones",
    description: "Conecta con sistemas ERP, PSA, EDI y CRM para eliminar trabajo manual.",
    icon: "Link"
  },
  {
    id: 4,
    title: "Protege márgenes automáticamente",
    description: "Aplica políticas de cancelación, reglas de reembolso y salvaguardas de suspensión a escala.",
    icon: "Shield"
  }
];

export const resellerFeaturesData = [
  {
    id: 1,
    title: "Aumenta autonomía del reseller",
    description: "Ofrece un portal seguro 24/7 de autoservicio para pedidos de licencias, renovaciones y cancelaciones.",
    icon: "UserCheck"
  },
  {
    id: 2,
    title: "Portales de cliente potentes",
    description: "Permite a partners gestionar suscripciones, facturación y presupuestos de forma independiente.",
    icon: "LayoutDashboard"
  },
  {
    id: 3,
    title: "Conectores listos para usar",
    description: "Integra sistemas ERP y PSA sin problemas para impulsar eficiencia y rentabilidad del reseller.",
    icon: "Plug"
  }
];

export const revenueFeaturesData = [
  {
    id: 1,
    title: "Modelos de precios personalizados",
    description: "Aplica descuentos por volumen y protección de márgenes flexible.",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Bundling y upselling inteligente",
    description: "Ofrece productos complementarios para aumentar el tamaño de los deals.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Workflows quote-to-bill automatizados",
    description: "Acelera ciclos de venta y mejora márgenes con automatización end-to-end.",
    icon: "FileCheck"
  }
];

export const quotingFeaturesData = [
  {
    id: 1,
    title: "Simplifica el proceso de cotización",
    description: "Combina generación instantánea de cotizaciones con aprobaciones automáticas y verificaciones de crédito."
  },
  {
    id: 2,
    title: "Asegura precisión en cotizaciones",
    description: "Accede a precios centralizados en tiempo real para todos los servicios y vendors."
  },
  {
    id: 3,
    title: "Acelera las ventas",
    description: "Permite a resellers solicitar y procesar cotizaciones de forma independiente."
  },
  {
    id: 4,
    title: "Optimiza el fulfillment",
    description: "Convierte cotizaciones aprobadas directamente en pedidos precisos, preservando términos y precios."
  }
];

export const futureFeaturesData = [
  {
    id: 1,
    title: "Onboarding de vendors sin fricciones",
    description: "Añade Microsoft, Adobe, Acronis y más con integraciones incorporadas.",
    icon: "UserPlus"
  },
  {
    id: 2,
    title: "Soporte multi-moneda y multi-región",
    description: "Opera globalmente con herramientas automatizadas de impuestos y cumplimiento.",
    icon: "Globe"
  },
  {
    id: 3,
    title: "Infraestructura escalable",
    description: "Gestiona miles de resellers eficientemente con automatización centralizada.",
    icon: "Server"
  }
];

export const distributorsFAQData = [
  {
    question: "¿Qué es la automatización de distribución IT?",
    answer: "La automatización de distribución IT estandariza las operaciones del canal, desde el onboarding de resellers hasta la facturación, para que los distribuidores escalen partners y productos sin escalar trabajo de back-office. Centraliza aprobaciones, precios, pedidos y workflows financieros en un proceso repetible que reduce errores y acelera el time-to-cash."
  },
  {
    question: "¿Se puede automatizar la distribución IT?",
    answer: "Sí. Automatizamos cada paso desde la activación del reseller hasta la facturación, manteniendo a los partners comprometidos con precios en vivo y términos flexibles mientras las operaciones se ejecutan en segundo plano. El resultado es adquisición más rápida, mayor retención y mayores ingresos impulsados por partners con menos trabajo manual."
  },
  {
    question: "¿Cómo manejan los distribuidores IT la facturación y provisioning?",
    answer: "Usa un motor quote-to-bill que convierte pedidos en activaciones conformes al vendor y facturas. Sincroniza catálogos en vivo, aplica reglas de precios y realiza reconciliación automática para que la facturación se mantenga precisa a medida que cambian las suscripciones."
  },
  {
    question: "¿Pueden los distribuidores IT escalar su negocio con automatización?",
    answer: "Absolutamente. Los distribuidores expanden portfolios y regiones mientras mantienen bajo el coste unitario por transacción. La automatización maneja catálogos multi-vendor, pedidos de alto volumen y facturación recurrente, para que el crecimiento venga de la configuración, no del headcount."
  }
];

export const testimonialData = {
  quote: "Cambiar a esta plataforma redujo nuestros costes de plataforma un 70% y aumentó nuestro segmento de clientes top un 25%, todo mientras mejoramos la experiencia del reseller y preparamos nuestro negocio cloud para el futuro.",
  author: "Hermann Ramacher",
  role: "CEO",
  company: "Advanced Digital Network Distribution GmbH",
  location: "Distribuidor IT, Europa"
};
